/* eslint-disable @typescript-eslint/indent */

import HeroContainer from '../../common/CourseDescriptionPage/HeroContainer';

const Hero = ({ isArmature = true }: { isArmature: boolean }) => {
  return (
    <section
      id="overview"
      data-title="Overview"
      className={` ${!isArmature && 'relative py-8 large:!py-14'}`}
      style={{
        // applying color as it was on figma
        background:
          'radial-gradient(39.37% 39.37% at 50% 50%, #1B2124 0%, #1A1A1A 100%), linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 100%), linear-gradient(90deg, rgba(20, 60, 182, 0.60) 0%, rgba(0, 0, 0, 0.18) 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.70) 0%, rgba(0, 0, 0, 0.70) 100%), #292426',
      }}
    >
      <div className="absolute top-0 h-[30%] w-full bg-gradient-to-b from-[#1a1a1a] to-transparent z-[5]" />
      <div className="absolute bottom-0 h-[30%] w-full bg-gradient-to-t from-[#1a1a1a] to-transparent z-[5]" />
      <div className="absolute w-screen inset-0 opacity-[7%] z-10">
        <img
          src="/images/homePageRevamp/noisebg-darkgray.webp"
          alt="Background img"
          className="w-screen large:w-full h-full"
        />
      </div>
      <div
        className="absolute w-[450px] h-[450px] -top-[10%] -left-[40%] medium:!w-[500px] medium:!h-[500px] medium:!-left-[20%] medium:!-top-[25%] large:!-left-[10%] large:!-top-[20%] z-10 blur-[150px] opacity-80"
        style={{ background: 'rgba(233, 120, 98, 0.30)', borderRadius: '225px' }}
      />
      <div
        className="absolute w-full h-[700px] inset-0 top-[5%] pointer-events-none z-0"
        style={{
          backgroundImage: `
                linear-gradient(to right, rgba(255,255,255,0.1) 1px, transparent 1px),
                linear-gradient(to top, rgba(255,255,255,0.1) 1px, transparent 1px)
              `,
          backgroundSize: '50px 50px',
          opacity: 0.3,
        }}
      />
      <HeroContainer isArmature={false} />
    </section>
  );
};

export default Hero;
